import type { SessionSyncPayload } from "@cold-case/shared/session-sync";

import type { AccusationPhaseState } from "@cold-case/shared/accusation-phase";

export type ApplySessionSyncHandlers = {
  caseResolved: boolean;
  applyJournal: (journal: Record<string, unknown>) => void;
  resumeAccusationPhase: (phase: AccusationPhaseState | null | undefined) => void;
  isAccusationPhaseActive: () => boolean;
  showOutcome: (result: { correct: boolean; solution_summary: string }) => void;
};

/**
 * Apply lightweight session sync. Resolved games short-circuit so a stale
 * accusationPhase cannot reopen vote/arrest UI over the outcome dialog.
 */
export function applySessionSyncPayload(
  data: SessionSyncPayload,
  handlers: ApplySessionSyncHandlers
): void {
  if (handlers.caseResolved) return;

  if (data.status === "resolved" && data.result) {
    handlers.showOutcome(data.result);
    return;
  }

  if (data.journal !== undefined) handlers.applyJournal(data.journal);

  if (data.accusationPhase) {
    handlers.resumeAccusationPhase(data.accusationPhase);
  } else if (handlers.isAccusationPhaseActive()) {
    handlers.resumeAccusationPhase(null);
  }
}
